import MUIToolbar from "@mui/material/Toolbar";

export const Toolbar = MUIToolbar;

export default Toolbar;
